// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".amount[data-v-ab80401e]{font-size:28px}", "",{"version":3,"sources":["webpack://src/components/modals/CreateInvoiceModal.vue"],"names":[],"mappings":"AAAA,yBAAyB,cAAc","sourcesContent":[".amount[data-v-ab80401e]{font-size:28px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
